// Nombres protegidos que no serán ofuscados
class HoloCardManager {
    constructor() {
        this._r0 = 15;
        this._r1 = false;
        this._c = document.querySelectorAll('.card');
        this._mt = window.innerWidth <= 1024 || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        this._init();
        this._preload();
        window.addEventListener('resize', this._handleResize.bind(this));
    }

    _init() {
        document.body.style.overflowX = 'none';
        const _s = document.createElement('style');
        _s.textContent = `
            html, body {
                max-width: 100%;
                overflow-x: hidden;
            }
            .card-container {
                width: auto;
                max-width: auto;
                margin: 0;
                padding: 0 1rem;
                box-sizing: border-box;
                object-fit: contain;
            }
            @media (max-width: 1024px) {
                .card {
                    width: auto !important;
                    margin: 0 !important;
                    transform: none !important;
                }
                .card-wrapper {
                    width: auto !important;
                    padding: 0 !important;
                }
                .holo-cards__title-wrapper {
                    margin-bottom: -16rem;
                    top: -23vw;
                }
            }
            @media (max-width: 479px) {
                .card {
                    width: auto !important;
                    margin: 0 !important;
                    transform: none !important;
                }
                .card-wrapper {
                    width: auto !important;
                    padding-top: 2vw !important;
                }
                .holo-cards__title-wrapper {
                    top: -37vw;
                    padding-bottom: 1vw;
                }
            }
        `;
        document.head.appendChild(_s);
    }

    _preload() {
        const _t = [
            getComputedStyle(document.documentElement).getPropertyValue('--HoloGrain'),
            getComputedStyle(document.documentElement).getPropertyValue('--HoloRainbow'),
            getComputedStyle(document.documentElement).getPropertyValue('--HoloIlu')
        ].filter(url => url);

        _t.forEach(url => {
            const img = new Image();
            img.src = url;
        });

        this._setupCards();
    }

    _setupCards() {
        this._c.forEach(card => {
            this._ensureElements(card);
            
            // Mantener nombres de eventos originales para compatibilidad
            card.addEventListener('mousemove', e => this._handlePointer(card, e));
            card.addEventListener('mouseleave', e => this._handleLeave(card, e));
            card.addEventListener('mouseenter', e => this._handleEnter(card, e));
            
            // Touch events
            card.addEventListener('touchmove', e => {
                e.preventDefault();
                const touch = e.touches[0];
                const rect = card.getBoundingClientRect();
                const touchEvent = {
                    clientX: touch.clientX - rect.left,
                    clientY: touch.clientY - rect.top,
                    type: 'touch'
                };
                this._handlePointer(card, touchEvent);
            }, { passive: false });
            
            card.addEventListener('touchend', e => this._handleLeave(card, e));
            card.addEventListener('touchstart', e => this._handleEnter(card, e));

            // Lazy loading
            const img = card.querySelector('img');
            if (img && img.loading === 'lazy') {
                img.addEventListener('load', () => img.classList.add('loaded'));
            }
        });
    }

    _ensureElements(card) {
        const wrapper = card.querySelector('.card-wrapper');
        const front = card.querySelector('.card-front');
        
        if (!wrapper || !front) return;

        if (!card.querySelector('.card__shine')) {
            const shine = document.createElement('div');
            shine.className = 'card__shine';
            front.appendChild(shine);
        }

        if (!card.querySelector('.card__glare')) {
            const glare = document.createElement('div');
            glare.className = 'card__glare';
            front.appendChild(glare);
        }
    }

    _handlePointer(card, e) {
        if (!card.classList.contains('interacting')) {
            card.classList.add('interacting');
        }

        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const cx = rect.width / 2;
        const cy = rect.height / 2;
        const px = (x / rect.width) * 100;
        const py = (y / rect.height) * 100;
        
        const dx = x - cx;
        const dy = y - cy;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const maxDist = Math.sqrt(cx * cx + cy * cy);
        const prox = Math.max(0, 1 - (dist / maxDist));

        this._updateEffects(card, px, py, prox);

        const rx = (this._r1 ? -1 : 1) * (y - cy) / cy * this._r0;
        const ry = (this._r1 ? 1 : -1) * (x - cx) / cx * this._r0;

        requestAnimationFrame(() => {
            card.style.transform = `
                perspective(1000px) 
                rotateX(${rx}deg) 
                rotateY(${ry}deg)
                scale3d(1.05, 1.05, 1.05)
            `;
        });
    }

    _updateEffects(card, px, py, prox) {
        const shine = card.querySelector('.card__shine');
        const glare = card.querySelector('.card__glare');
        const rarity = card.dataset.rarity;

        if (shine) {
            shine.style.opacity = `${prox * 0.7}`;
            shine.style.backgroundPosition = `${px}% ${py}%`;
        }

        if (glare) {
            glare.style.opacity = `${prox * 0.7}`;
            
            if (rarity === 'rare rainbow' || rarity === 'rare holo v') {
                const intensity = rarity === 'rare rainbow' ? 0.8 : 0.9;
                glare.style.backgroundImage = `radial-gradient(
                    farthest-corner circle at ${px}% ${py}%,
                    hsla(0, 0%, 100%, ${prox * intensity}) 10%,
                    hsla(0, 0%, 100%, ${prox * (intensity - 0.1)}) 20%,
                    hsla(0, 0%, 0%, ${prox * (intensity - 0.1)}) 90%
                )`;
            }
        }

        this._updateVars(card, px, py, prox);
    }

    _updateVars(card, px, py, prox) {
        const vars = {
            '--gradient-opacity': prox.toString(),
            '--mouse-x': `${px}%`,
            '--mouse-y': `${py}%`,
            '--pos': `${px}% ${py}%`,
            '--posx': `${px}%`,
            '--posy': `${py}%`,
            '--hyp': prox.toString()
        };

        Object.entries(vars).forEach(([key, value]) => {
            card.style.setProperty(key, value);
        });
    }

    _handleLeave(card) {
        card.classList.remove('interacting');
        
        const shine = card.querySelector('.card__shine');
        const glare = card.querySelector('.card__glare');
        
        if (shine) shine.style.opacity = '0';
        if (glare) glare.style.opacity = '0';

        requestAnimationFrame(() => {
            card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
        });
        
        this._resetCard(card);
    }

    _handleEnter(card) {
        card.style.setProperty('--active-blur', '1');
        card.style.setProperty('--active-glare', '1');
    }

    _resetCard(card) {
        const vars = {
            '--gradient-opacity': '0',
            '--active-blur': '0',
            '--active-glare': '0',
            '--mouse-x': '50%',
            '--mouse-y': '50%',
            '--pos': '50% 50%',
            '--posx': '50%',
            '--posy': '50%',
            '--hyp': '0'
        };

        Object.entries(vars).forEach(([key, value]) => {
            card.style.setProperty(key, value);
        });
    }

    _handleResize() {
        this._mt = window.innerWidth <= 1024 || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    }
}

// Mantener inicialización original
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new HoloCardManager());
} else {
    new HoloCardManager();
}